import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagFI = function FlagFI() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0052B4",
    d: "M49.788 21.74H19.565V.593a24.83 24.83 0 0 0-6.522 2.446v18.7H.213a25.213 25.213 0 0 0 0 6.52h12.831v18.7a24.831 24.831 0 0 0 6.522 2.446V28.26h30.223a25.26 25.26 0 0 0 0-6.522Z"
  }));
};
FlagFI.displayName = 'FlagFI';
export default withFlagWrapper(FlagFI);
//# sourceMappingURL=index.js.map